import { useEffect, useState } from 'react';
import { AnchorAPI } from '../../../modules/AnchorAPI';
import { UserVerificationState } from '../../../modules/AnchorAPI/user/fetchUserVerificationState';

export function useEmailVerificationState() {
  const [
    userVerificationState,
    setUserVerificationState,
  ] = useState<UserVerificationState | null>(null);
  useEffect(() => {
    AnchorAPI.fetchUserVerificationState().then(res => {
      setUserVerificationState(res.userVerificationState);
    });
  }, []);

  return {
    userVerificationState,
  };
}
